// v10/src/services/serviceComponentsService.js
//
// Wrapper de los endpoints del feature "Service por componente".
// Distinto de componentLifespanService.js (A6.1 vida límite/TBO).

import api from './apiService';

const base = (aircraftId) => `/api/aircraft/${aircraftId}/service-components`;

const serviceComponentsService = {
  // ── Listado y CRUD por aeronave ─────────────────────────────────
  listByAircraft: (aircraftId, params = {}) => api.get(base(aircraftId), { params }),
  create:         (aircraftId, data)         => api.post(base(aircraftId), data),
  update:         (aircraftId, componentId, data) => api.put(`${base(aircraftId)}/${componentId}`, data),
  remove:         (aircraftId, componentId)  => api.delete(`${base(aircraftId)}/${componentId}`),
  restore:        (aircraftId, componentId)  => api.patch(`${base(aircraftId)}/${componentId}/restore`),

  // ── Service hecho ───────────────────────────────────────────────
  markServiceDone: (aircraftId, componentId, data = {}) =>
    api.post(`${base(aircraftId)}/${componentId}/service`, data),

  // ── Historial ───────────────────────────────────────────────────
  getHistory: (aircraftId, componentId, params = {}) =>
    api.get(`${base(aircraftId)}/${componentId}/history`, { params }),

  // ── Globals ─────────────────────────────────────────────────────
  getDashboard: () => api.get('/api/service-components/dashboard'),
  getTemplates: () => api.get('/api/service-components/templates'),
};

export default serviceComponentsService;
